<template>
  <div class="infuse-layout-auth-azureb2c flex flex-col items-start gap-4">
    <div class="infuse-layout-auth-azureb2c-logo hidden"></div>

    <p class="text-neutral-600 my-4" v-if="introText">{{ t('auth.signIn.intro') }}</p>

    <slot />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
// check if translation is a blank string; v-if hides the P tag if so.
const introText = t('auth.signIn.intro');
</script>
